import store from "../store";

export default function authHeader() {
    const res = store.getState()?.auth
    if (res?.token) {
        return { Authorization: 'Bearer ' + res?.token, refreshToken: res?.refreshToken };
    } else {
        return {};
    }
}